import { TransformToCamelCase } from '@/types/general';
import { IApiPrepareCheckoutResponse } from '@typings/checkout';

export const GET_CHECKOUT_PREPARE_QUERY_KEY = 'GET_CHECKOUT_PREPARE_QUERY_KEY';

export type ApiPrepareCheckoutResponse = TransformToCamelCase<IApiPrepareCheckoutResponse>;
